export default __webpack_public_path__ + "static/tablet_KV15-cdadd2156df9f60bbe5865b8580c870e.mp4";